import { z } from 'zod';

export const AvailabilityTypeZod = z.union([
    z.literal('full_doc'),
    z.literal('participation_only'),
    z.literal('no_details'),
    z.literal('validity'),
]);
export type AvailabilityType = z.infer<typeof AvailabilityTypeZod>;
